<template>
  <section>
    <div class="container-fluid service_header">
      <div class="container px-0">
        <div class="row">
          <div class="col-md-7">
            <h1>
              <strong> Hard-hitting </strong> and
              <strong>Profit-Yielding </strong> stocks that will generate
              returns close to <strong> 150% to 300% over 2 years </strong>of
              investment.
            </h1>
          </div>
          <div class="col-md-5 mb-5 stocks">
            <ul class="card_list">
              <li class="card elevation-2">
                <img
                  src="data:image/jpeg;base64,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"
                />
                <p>
                  <span>Arrow Greentech</span>
                  <span class="return__text">
                    <i class="fas fa-sort-up" aria-hidden="true"></i> Return 1570%</span
                  >
                </p>
              </li>
              <li class="card elevation-2">
                <img
                  src="https://moneybapu.com/wp-content/uploads/2019/01/Logo-LAOPALA.jpg"
                  alt="La Opala RG company logo"
                />
                <p>
                  <span>La Opalla</span>
                  <span class="return__text">
                    <i class="fas fa-sort-up" aria-hidden="true"></i> Return 1325%</span
                  >
                </p>
              </li>
              <li class="card elevation-2">
                <img
                  src="data:image/jpeg;base64,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"
                />
                <p>
                  <span>Marksans Pharma</span>
                  <span class="return__text">
                    <i class="fas fa-sort-up" aria-hidden="true"></i> Return 677%</span
                  >
                </p>
              </li>
              <li class="card elevation-2">
                <img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAABRCAMAAAAgnC40AAAAqFBMVEX///8AXKJXlcwAWqEAWKD5+/0AW6EAU50AVp/0+Pvt8/j7/f7x9vre6vMAUZyHstPR4u7L3uwsdLEQZqgabasATpotd7Hm7/bZ5/FTkcAATJmxzuO60+ZQkMpYlszG2uo9gLZHiLtjmsUdZ6iavdqqyOBxoMl/rNB0pMu50+qItNtwpdRjndBJjMhel8RGhLkAQ5SfwdyArthwpNScweKSut5bjb6HrdB/y8Y+AAALpElEQVRoge2aC3ObOhaApSCQeGPeBhzehqQJjts0+f//bM8RDzu36d7O3HU7s7tKpo0FSJ+OzlOYkH/cis7854P847aj4qz+aQhStoLR/k/LI6eCwm//Z+VRtIxCcxT7N05q7h7KMrX1C0UokEKJ3i99RE28snwobief5HA43D19+f5gz3N4LUcKzXnf5jST4vXr093h8Ly7Gcb5cHd3d4CfL68lLN+LHSmL7H3VUDPtvwDCHd729VYU+tPd2p4fVWL7koJGGwVRH5+3W+6SG2F4h2WC+8M3gxizLKgzrBSpRZIvh/sV4+FGGOeN4skmei0ptIssbP8EcN82ju+3oTAf13UeSqIeZwpnXCmS2uG1ReynlePbbXYl+bIqxoNK3NlGss1Sk5orVOwtsltZn9KbYKRPUjfun7+qpGCK9BfNaqlGEyEXH0yzWNT0vrgJhjdjHA4JSVoxU6yy0JtM6qvCc6J+XbblNjpa3i9bYpoNl3rxtlEMmSYxqAgTsps9x11/Q4zDk0V6uSU8XnVQf5eyUOS2HE318XBzaRx6YsW4JSLwNgoHA5yY/w1sUs5KdBtpePcw+uE+JbkG61bYeek3XY5yiKpzq6F2uMSateg20kifZKgwzBE1g9WLkZidIin8ZL7g1Lr5HTHuy5tgSL9xeDWTE8ymsXzp7hXcCx7CpB7VUElT8nC4nd8gj7NqeD6oBgsX/cwDqREhzmlUDBW1JwXuyRfjNhj9vOEFTsxO8yQFFYqi8FZmF+YoEMMlO9Dmw41iCklxwx9Ih6Jn4Lah7fwghBYvauAihjZIjJtFWP3bAfXuGsMuPWi7NROVGBQwQJvvb5VvkP6Aa5TJOKs/2/kRtkubN+XweLOiIYEdfyAe5sHM/wTDqlFr6JmUcKP34/X/UDNfnw+vxI7RYOknKW+C5YJoS/IA/uWGlUtyf3i01AkzHtH8eLlDJ8+rhLwenm/kNOb28Az53xmdt0Z/cJJJiG7DGYjx9fn7Tcs4/evzA7FD6bGqv5iCLsM/A7wdhuGbtuTwRScydmhi/4HDGoX06nvT/P58O/1cWvlcztKHWHq6mi2dGFuEkUBmdGsM8vBVJ72QyZZoh1ImYKbn+rILw7z6+Pob6nuzhyzwKFMMylhwOrruWIdMRnvqnCA1f9X/fpT/AEeZEGs/c0DAZ5qiMGXJRCuDJOVvoYBmmFAQiHXurTF2AqVNfuuJi961/BpEYTwYbxbN/k0rm1ZgsiEZhKBv+Z85AdOL8RQAgABTrZr+RsnWLzTTznt3GNxzkf7xM0n1jxP8v/0PNNOyi3JnX7IEHdr1B6mG6nUn9tu7cpcuXSZcvBwJfrzT+vjx49Xtk5q6FVWE0k75YvzW2EzDmvbbUzN1QGgOzfR+cZTqrgkYF8ExlbPnx2Zaz3eM96YZL36knODaJXdNhql523IEy52Oo/yjow64Q8aEw6f5skGdrF2zvDKLHIwWahBl7Taa2XMH4ioTfE4HR8fJ1rPJ1I8iZctG9SpznJdpE8CuzXjWrotM4shhOOUxYygKP9QEc9odDmXEVIlX4J2i0T2sTcXObfAdhwyj2tcBF/KIwYXY5q7yqzQabKf5qSJzk+1JD89HoPBfMGpKQyw8MyrEW1fsivObENkRFcTwKYvXhe8ghEkMX2Ebhrp3tMBNdaM8ueqCIS4YinLBGAQNQxFtpy6ezyFLc5YD1aTWEKPIQLLneSONTtRyp/8ew/YZn+YCcvaiP8WwQqgnG8epVwNAjEDTnPIKQ4c+p1tByVKO/hrG23X+/VOMnCntrnMUvm4yYChNrIhZPWaMnQMFzg/50t9j6DWHavWKAzHW5RinC4Y5CRarhXI51gYMp+sY5Sd9w3C5xi/C+HUMUkSKxvbFtgJU0XEnm1fEmrZipC0TI9gDmHZywRiMis+n/jPGHuZYzo/Uuf2abhB94EJhQb2CAAYNfDztCP0woBtGxxWlJKrrKFG+YbBaTamCh7mAoQBGDdn17HXKqcE2HdNfwiB63zogEDqlGwZkx0vbMPQTZxXsnQfOYFJXDKU2SM8pbxOSnDSJodAZo2MMB+D48VcwYCFHPHISsb1iXLUVo4TaBTfdqLnCvE0aWPGNDnXeLL1CaTSQ4M8W3UE6Bx6JBWBIRniNIX6CQcz0CB6A7/UZQxy9VTfYijFAJVHoEFQ6h2auuUoDx0P1iDprAreColneiaQdtIpxH57XY4W1q4GVQtPQRfyIASB5yxS5q9eWklRssZQkhjXUzTRNsUKFr19jEBtqirYchRISG5zXFj2IPnEHT7XMvWDbyQGsw8F1fIZB8ABdGxYMdzHJi9/oQRgsyqIocqC4nD3WhkFyzsR+ooChNhHl9brwgjJ+NjGYopBmjUpipjDcN4lxee+bzPZXagobyU/cl944oCWtbFSjfDI/YJhuxgI/AAxiB6CxfmHrqm4XPosqeUMZgT25qaUaZSMol6evgKH4RQrNg3vskwzlxhHUuv8ZhgelTFXuyrLceZ3GNGp/wCBqHeEhc4gzOhwU/jSOY61BzTGbjVpFIJhqHBtw9tr8phUwKI1PVVX5PbHeMjb1Rb4HFZXHcZ9iwH5uIQ01UhrNFQY4NzwrCeVOBBGIHX4F48765YNd4GCdDBkA1Zz5YAcwNE1wzgUkFkmcwf0BVNGcS3KXale6MauoHjuK2LQJHLao1MVg16So5IJqEoN4jcIh6YGf6vIViKIWHCsywVkzj6QGYnYtGuY39gSpF9zBw0I+MzC2vZK1fSgmU9xalp22uOPBLE6B37VwRL1lcR0Ha5j/tLxzU+/3Y35dCydFN+3rfdOVK3mRL62XB/W5u6/rpp9zQJJC/xb3SvgAxpn2861zU0v4CMZgFX2+22osHUbdXg6almEYfw20qmEkhvXzokyHZ6w//Q2S/8aWgBtY9l738nzJ6AysPszEk3kpegko3ot8OU7StwfKvryUAWo6a5Zpy0ESWeTry8PQpdrocvAmA/+3TbwKfQbeN0J2UEknmgwBZAxzddK1aO25gGijvmFw0c8+2PcknXERDpLHGpWWTZshlP5cAyTVm41pRIuK1zNMsZP4lJJdTH2/bSeidm3YtqGNThs6/AFI93wcqQ/qbJ2yU+eeXuQbiiFCP2OdXlKSvzQmOPcsHN0pki89eyHfRptdNhbDsOl1IfMKdMs4XKpk4LmN+gUjZUKhvrGHfcDrpiPqGFXjESY385f42FQRROgJRnYzWLuboXO2xgzzfVeRtUfK94bfQreXVSlWSA6mjz094tzGm/PhLUIZzKWHHVY2vv474QvqMAhSPE33pcD3MuNQB75YaJ65sk7qyER31pQVxGgDuZakhYyIuMtbVlfUmLrp44ucUd3jAL0mMdQ+OxX6JxgtYuT0HOTEjQfFw0Elhr5nO4khxiLHR/NokA+EZFL2bxk839P5xapV45uSFcOqsj2oUhpT6YXMzoH+fMYgust44/0Eww3SqVGrd4/2G4a1Z+WMAdkFjphHGJsTn5JJtNWQoLZU0hFBbu9dMIgr81j7JKTmmm50hQFu8ej4yacY5pHqRdi3ZRLAJv9VGrzp+16/YASwKb08UFUrLmfyBAYBly1x0cXkGaTwIrNqKG13iLF9hUV3s7N5wVBn3YCkxDz5ZhIGlWG00ycY17pBSqUGFS3XrnhnGWX8gp9d1hm2DN+8nzWG9YaVThnuZU4n204guOUmOUfuBaNKbfAGEsMI95DKvQymVcXqqqL6XlkwzgkOAIXrYCSFD0lZLRYyteNBVUF6gMMOGW3b0cI/5t0pWxFXYSQ9Q894G8SJ6kbNSOmWjhXUads4gQwTDNYTDVp0Tsw3B4oATR5IWCeZBapQvLcB+A0wWCiyZb7Xj+s4ajn5YVPKxRXHcTzi9w3L46KD9hCHdS6NyRuO49E1iDGE7dslgNrv0P1uEeu9M4g3woSJm+Dxi0GsAf8i6llOZsrR0WmlzTDtzyDBfwGrWALN5WWRJgAAAABJRU5ErkJggg=="
                />
                <p>
                  <span>Gulshan Poly</span>
                  <span class="return__text">
                    <i class="fas fa-sort-up" aria-hidden="true"></i> Return 590%</span
                  >
                </p>
              </li>
              <!-- <li class="card elevation-2">
                        <img src="data:image/jpeg;base64,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">
                        <p>
                          <span> <i class="fas fa-arrow-up" aria-hidden="true"></i> 530%</span>
                          <span>Atul Auto </span>
                        </p>
                    </li>
                    <li class="card elevation-2">
                        <img src="data:image/png;base64,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">
                        <p>
                        <span> <i class="fas fa-arrow-up" aria-hidden="true"></i> 400% </span>
                        <span>Acrysil </span>
                        </p>
                    </li> -->
            </ul>
            <p class="white--text">FEW OF OUR RECOMMENDED STOCKS</p>
          </div>
        </div>
        <div class="custom-shape-divider-bottom-1607258662">
          <svg
            aria-hidden="true"
            focusable="false"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
              class="shape-fill"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <div class="container features">
      <div class="row">
        <div class="col-md-12 my-4">
          <h2 class="mb-4 gray--text h1">
            The easiest way to buy High Quality stocks recommended by Experts:
          </h2>
          <ul class="feature_list">
            <li>
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <p>
                One stock a month, we do the research for you.
              </p>
            </li>
            <li>
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <p>You need to invest only 5 minutes a month.</p>
            </li>
            <li>
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <p>Expert Analysis of New Investing Trends</p>
            </li>
            <li>
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <p>
                Clear Buy, Sell and Hold instructions & timely updates for every
                stock in the portfolio, so you can make your decisions as simply
                as 1-2-3
              </p>
            </li>
            <li>
              <i class="fas fa-check-circle" aria-hidden="true"></i>
              <p>Direct Q&A with the experts.</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" id="testimonials_section">
          <h2 class="text-center h2 my-5 white--text">
            What our Clients are saying
          </h2>
          <div class="col-md-6 col-md-offset-3 testimonials_card elevation-1">
            <div class="pa-4">
              <div class="d-flex">
                <img
                  src="../assets/gws_jay.jpg"
                  class="img-circle testimonial_img"
                  alt="Photo of Jai Shah, Grow With Stocks client"
                />
                <h4 class="h2">Jai Shah</h4>
              </div>
              <p class="">
                I Joined GWS services 4 years ago and here is my honest review
                on it. I would like to say that I am in stock market because of
                "GWS". My total investment in last 4 years is 7 Lacs and I have
                returns of 21+ Lacs because of GWS. There is no other way I
                could have, made this kind of return, so I am very thankful to
                GWS family. I would like to mention that within 2 years many
                stocks in my portfolio made huge returns like 3 to 6 times. I am
                very happy with GWS. Thank You. "
              </p>
            </div>
          </div>
          <div class="col-md-6 col-md-offset-3 testimonials_card elevation-1">
            <div class="pa-4">
              <div class="d-flex">
                <img
                  src="../assets/gws_gayathri.jpg"
                  class="img-circle testimonial_img"
                  alt="Photo of Gayathri Umachandran, Grow With Stocks client"
                />
                <h4 class="h2">Gayathri Umachandran</h4>
              </div>
              <p class="">
                I had started trading a few years back, but mostly did it from
                random suggestions I got from news channels and through some
                irregular study. Only in the year 2014, I had made my
                association with GROW WITH STOCKS and took an annual
                subscription. I have not repented ever since. The fact that I
                recommend it to my friends and even mentioned it in my Facebook
                status, shows my respect for the GROW WITH STOCKS team."
              </p>
            </div>
          </div>
          <div class="col-md-6 col-md-offset-3 testimonials_card elevation-1">
            <div class="pa-4">
              <div class="d-flex">
                <img
                  src="../assets/gws_jay_shankar.jpeg"
                  class="img-circle testimonial_img"
                  alt="Photo of Jai Shankar, Grow With Stocks client"
                />
                <h4 class="h2">Jai Shankar</h4>
              </div>
              <p class="">
                I have been associated with GWS since 2012 and initially when I
                subscribed to GWS recommendations was hesitant to buy the stocks
                and wanted to watch the performance before I get conviction to
                buy, but that cost a lot to me as I missed many great stocks
                nevertheless the stocks which I bough afterwards were also a
                great success and helped me in achieving my financial goal.
              </p>
            </div>
          </div>
          <div
            class="col-md-6 col-md-offset-3 my-4 white elevation-1"
            id="info"
          >
            <p class="text-center h3 my-5">
              Hindustan foods recommended by us in May 2020 is now up by
              <span class="green--text font-weight-bold">150%</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <section id="info">
      <div class="row">
        <div class="col-md-6 col-md-offset-3 col my-4">
          <p class="text-center h3 my-4">
            hindustan foods recommended by us in May 2020 is now up by
            <span class="green--text">120%</span>
          </p>
        </div>
      </div>
    </section> -->
    <div class="container-fluid contact_us_form">
      <div class="row mt-5">
        <div class="col-sm-4 col-sm-offset-4">
          <h3 class="h1 text-center white--text">Subscribe</h3>
          <hr class="white--text" />
          <p class="h4 text-center white--text">To receive free trial stocks</p>
          <form v-on:submit.prevent="onSubmit" class="pa-4 elevation-1">
            <input
              type="text"
              placeholder="Name"
              class="form-control form-control-lg my-4"
              required
              v-model="name"
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            />
            <p class="white--text" v-if="nameErrors.length">
              {{ nameErrors[0] }}
            </p>
            <input
              type="email"
              placeholder="Email Address"
              class="form-control form-control-lg my-4"
              required
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
              v-model="email"
            />
            <p class="white--text" v-if="emailErrors.length">
              {{ emailErrors[0] }}
            </p>
            <input
              type="text"
              placeholder="Mobile Number"
              class="form-control form-control-lg my-4"
              required
              v-model="mobile"
              @input="$v.mobile.$touch()"
              @blur="$v.mobile.$touch()"
            />
            <p class="white--text" v-if="mobileErrors.length">
              {{ mobileErrors[0] }}
            </p>
            <button type="submit" class="btn btn_custom btn_contact mt-5">
              Subscribe
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
import lb from "../util/lb";

export default {
  name: "contact",
  mixins: [validationMixin],
  validations: {
    name: { required },
    email: { required, email },
    mobile: { numeric, required, maxLength: maxLength(10) }
  },
  data() {
    return {
      name: null,
      email: null,
      mobile: null,
      level: null
    };
  },
  computed: {
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      !this.$v.mobile.required && errors.push("Mobile Number is required.");
      !this.$v.mobile.maxLength && errors.push("Enter correct Mobile Number.");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    }
  },
  methods: {
    async onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const response = await lb.post("/api/Messages/sendContactUsDetails", {
            contactInfo: {
              name: this.name,
              level: "New lead",
              email: this.email,
              mobile: this.mobile
            }
          });
          this.$v.$reset();
          this.name = null;
          this.email = null;
          this.mobile = null;
          this.$toasted.show(
            "Thanks for your query, we will contact you shortly.",
            {
              duration: 5000,
              position: "bottom-right"
            }
          );
          if (window.innerWidth < 600) {
            window.open("https://wa.me/message/G4RYS7PC53CKF1", "_blank");
          }
        } catch (err) {
          console.log(err);
          this.$toasted.show("Oops some error occurred", {
            duration: 2000,
            position: "bottom-right"
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.service_header {
  position: relative;
  background-color: #1a7055;
  h1 {
    color: #ffffff;
    font-weight: 500;
    line-height: 1.5em;
    strong {
      font-size: 1.2em;
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    }
    margin: 50px 10px 80px;
  }
  span {
    font-weight: 500;
    margin: 20px 0;
    color: #ffffff;
    font-size: 20px;
  }
  p {
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 50px;
    color: #000000;
  }
  ul {
    li {
      font-weight: 500;
      color: white;
      strong {
        font-size: 1.2em;
      }
    }
  }
  .feature_list {
    font-size: 20px;
    margin: 20px 0;
    ul {
      li {
        display: flex;
        align-items: baseline;
        i {
          width: 50px;
        }
      }
    }
    strong {
      text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    }
  }
  .card_list {
    display: block;
    margin: auto;
    .card {
      margin: 15px 0;
      padding: 20px;
      background-color: #fff;
      color: #000;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top-left-radius: 15px;
      border-bottom-right-radius: 15px;
      .return__text {
        color: #01b408;
        font-weight: bold;
      }
      img {
        width: auto;
        height: 40px;
      }
      p {
        display: flex;
        flex-direction: column;
        text-align: right;
        margin-bottom: 0;
      }
      span {
        i {
          color: #01b408;
          font-size: 1.8em;
          position: relative;
          top: 10px;
        }
        font-size: 14px;
        color: #01b408;
        color: #000;
        margin: 0;
        text-align: right;
      }
    }
  }
}

p {
  color: #696969;
}

.contact_us_form {
  padding: 80px 0;
  background-color: #000;
  p {
    font-size: 2.2em;
  }
  form {
    border-radius: 10px;
    input {
      height: 50px;
    }
    p {
      font-size: 12px;
    }
  }
}

.features {
  h2 {
    margin: 40px 0;
    text-align: center;
    font-size: 34px;
  }
  ul {
    margin: 20px;
    list-style: none;
    li {
      p {
        color: #000;
        font-family: "Lato", sans-serif;
        font-size: 24px;
        position: relative;
        bottom: 4px;
      }
      display: flex;
      align-items: baseline;
      margin: 30px 0;
      font-size: 25px;
      border-bottom: 1px solid rgb(145, 145, 145);
      i {
        margin-right: 50px;
        color: #01b408;
      }
    }
  }
}

.custom-shape-divider-bottom-1607258662 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  line-height: 0;
  transform: rotate(180deg);
}

.custom-shape-divider-bottom-1607258662 svg {
  position: relative;
  display: block;
  width: calc(135% + 1.3px);
  height: 181px;
}

.custom-shape-divider-bottom-1607258662 .shape-fill {
  fill: #ffffff;
}

.infotext {
  line-height: 1.5em;
}

.btn_custom {
  background-color: #31cc9a !important;
  font-weight: 800;
  display: block;
  margin: 10px auto;
  height: 70px;
  width: 300px;
  color: #000;
  font-size: 1.6em;
}

#testimonials_section {
  padding: 30px 20px;
  background-color: #1a7055;
  position: relative;
  padding-bottom: 150px;
  .testimonials_card {
    position: relative;
    margin-bottom: 30px;
    border-radius: 10px;
    z-index: 0;
    background-color: #efefef;
    color: #000;
    h4 {
      width: 90%;
      margin-left: 20px;
    }
    p {
      font-weight: 400;
      margin-top: 20px;
      font-size: 1.3em;
      color: #000;
      font-family: "Lato", sans-serif;
    }
    img {
      // position: absolute;
      height: 70px;
      width: 70px;
      // top: -20px;
      // left: 50%;
    }
  }

  .testimonials_card::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
    border-radius: 10px;
    box-shadow: -1px -1px 4px rgba(0, 0, 0, 0.15);
  }

  /* Second sheet of testimonials_card */
  .testimonials_card::before {
    left: 7px;
    top: 5px;
    z-index: -1;
  }

  #info {
    position: absolute;
    bottom: -90px;
    border-radius: 10px;
    width: 50%;
    overflow: auto;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
    p {
      color: #000;
      line-height: 1.3em;
      span {
        font-size: 1.2em;
      }
    }
    background: rgb(173, 173, 173);
    background: linear-gradient(
      0deg,
      rgba(173, 173, 173, 1) 0%,
      rgba(252, 252, 252, 1) 87%
    );
  }
}

.testimonial_img {
  height: 40px;
  width: 40px;
  display: block;
  margin: auto;
}
.v-carousel >>> .v-carousel__prev {
  display: none;
}
.v-carousel >>> .v-carousel__next {
  display: none;
}
/*==========  Mobile First Method  ==========*/

/* Custom, iPhone Retina */
@media only screen and (min-width: 320px) {
}

/* Extra Small Devices, Phones */
@media only screen and (min-width: 480px) {
}

/* Small Devices, Tablets */
@media only screen and (min-width: 768px) {
}

/* Medium Devices, Desktops */
@media only screen and (min-width: 992px) {
}

/* Large Devices, Wide Screens */
@media only screen and (min-width: 1200px) {
}

/*==========  Non-Mobile First Method  ==========*/

/* Large Devices, Wide Screens */
@media only screen and (max-width: 1200px) {
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
}

/* Small Devices, Tablets */
@media only screen and (max-width: 768px) {
}

/* Extra Small Devices, Phones */
@media only screen and (max-width: 480px) {
  .custom-shape-divider-bottom-1607258662 {
    display: none;
  }
  .service_header {
    position: relative;
    background-color: #1a7055;
    h1 {
      color: #ffffff;
      font-weight: 500;
      font-size: 28px;
      text-align: left;
      strong {
        font-size: 1.1em;
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
      }
      margin: 40px 0px;
    }
    span {
      font-weight: 500;
      margin: 20px 0;
      color: #ffffff;
      font-size: 20px;
    }
    .stocks {
      display: flex;
      flex-direction: column-reverse;
    }
    p {
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      margin-bottom: 20px;
      color: #000000;
    }
    ul {
      li {
        font-weight: 500;
        color: white;
        font-size: 16px;
        strong {
          font-size: 1.2em;
        }
      }
    }
    .feature_list {
      font-size: 20px;
      margin: 20px 0;
      strong {
        text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
      }
    }
    .card_list {
      display: block;
      margin: 0;
      padding: 0 20px;
      border-radius: 10px;
      .card {
        padding: 13px;
        background-color: #fff;
        color: #000;
        list-style: none;
        display: flex;
        justify-content: space-between;
        img {
          width: auto;
          height: 40px;
        }
        p {
          display: flex;
          flex-direction: column;
        }
        span {
          i {
            color: #31cc9a;
            font-size: 1.8em;
          }
          font-size: 14px;
          color: #000;
          margin: 0;
        }
      }
    }
  }
  .features {
    color: #000;
    h2 {
      margin: 40px 0;
      text-align: left;
      font-size: 24px;
    }
    ul {
      padding-left: 0px;
      width: 100%;
      margin: auto;
      list-style: none;
      li {
        p {
          color: #000;
          font-family: "Lato", sans-serif;
          font-size: 19px;
          position: relative;
          bottom: 4px;
        }
        display: flex;
        align-items: baseline;
        margin: 30px 0;
        font-size: 25px;
        border-bottom: 1px solid rgb(145, 145, 145);
        i {
          margin-right: 10px;
          color: #01b408;
        }
      }
    }
  }
  .contact_us_form {
    padding: 80px 0;
    background-color: #000;
    p {
      font-size: 1.7em;
    }
  }
  .btn_contact {
    display: block;
    margin: auto;
  }
  #info {
    position: absolute;
    bottom: -90px;
    border-radius: 10px;
    width: 90% !important;
    overflow: auto;
    margin: auto;
    position: absolute;
    left: 0;
    right: 0;
  }
}

/* Custom, iPhone Retina */
@media only screen and (max-width: 320px) {
}
</style>



// WEBPACK FOOTER //
// src/views/Services.vue